import React from "react";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import PhoneOutlinedIcon from "@mui/icons-material/PhoneOutlined";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import CalendarTodayOutlinedIcon from "@mui/icons-material/CalendarTodayOutlined";
import { formatUTCDate, formatUTCDateTime } from "../../../../../../../../utils/formatUTCDate";
import { LeftSectionItemId, NEVER_LOGGED_IN } from "./leftSection.constants";
import AccessTimeOutlinedIcon from "@mui/icons-material/AccessTimeOutlined";

export const renderIcon = (id: LeftSectionItemId) => {
    switch (id) {
        case LeftSectionItemId.EMAIL:
            return <EmailOutlinedIcon fontSize="small" />;
        case LeftSectionItemId.PHONE_NUMBER:
            return <PhoneOutlinedIcon fontSize="small" />;
        case LeftSectionItemId.STATE:
            return <LocationOnOutlinedIcon fontSize="small" />;
        case LeftSectionItemId.CREATED_ON:
            return <CalendarTodayOutlinedIcon fontSize="small" />;
        case LeftSectionItemId.LAST_LOGIN_ON:
            return <AccessTimeOutlinedIcon fontSize="small" />;
        default:
            return null;
    }
};

export const renderValue = (value: string, id: LeftSectionItemId) => {
    if (id === LeftSectionItemId.CREATED_ON) {
        return `Registered On ${formatUTCDate({dateString: value, dateMonthYear: true})}`;
    }
    if (id === LeftSectionItemId.LAST_LOGIN_ON && value !== NEVER_LOGGED_IN) {
        return `Last Logged In On ${formatUTCDateTime(value, false, true)}`;
    }
    return value;
};
